import { render, staticRenderFns } from "./VesselAnchorPointsLayer.vue?vue&type=template&id=cef771a2&"
import script from "./VesselAnchorPointsLayer.vue?vue&type=script&lang=js&"
export * from "./VesselAnchorPointsLayer.vue?vue&type=script&lang=js&"
import style0 from "./VesselAnchorPointsLayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports